var _path, _circle, _path2, _path3, _circle2, _path4, _circle3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBobLockupDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183 132",
    width: 183,
    height: 132,
    role: "img",
    "aria-label": "bob \\u2014 business operations base",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5 V72.5",
    fill: "none",
    stroke: "#f0fdfa",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 72.5,
    r: 22,
    fill: "none",
    stroke: "#f0fdfa",
    strokeWidth: 13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 53.45 A22 22 0 0 0 72.45 83.5",
    fill: "none",
    stroke: "#f0fdfa",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 91.55 A22 22 0 0 0 110.55 61.5",
    fill: "none",
    stroke: "#5eead4",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 72.5,
    r: 7.5,
    fill: "#f0fdfa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 6.5 V72.5",
    fill: "none",
    stroke: "#f0fdfa",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 72.5,
    r: 22,
    fill: "none",
    stroke: "#f0fdfa",
    strokeWidth: 13
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 7,
    y: 126,
    fontFamily: "Inter, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 500,
    letterSpacing: 1.5,
    fill: "#99f6e4"
  }, "business operations base")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobLockupDark);
export default __webpack_public_path__ + "static/media/bob-lockup-dark.3bc0d4a92ace4e95a30f8fd9c1be1366.svg";
export { ForwardRef as ReactComponent };